import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import {
  SearchComponent,
  FooterComponent,
  TabbedComponent,
  CardSliderComponent,
  SliderComponent,
  DrawerComponent,
  NpSetLayoutDirective,
  NpSelectDirective,
  NpTableDirective,
  ValidNextPageRoutePipe,
  AlertComponent,
} from "@cvx/nextpage";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { SpinnerComponent } from "./shared/spinner/spinner.component";
import { ValidationComponent } from "./validation/validation.component";
import { ActionButtonComponent } from "./shared/action-button/action-button.component";
import { FileUploadComponent } from "./shared/file-upload/file-upload.component";
import { PicklistSelectComponent } from "./shared/picklist/picklist-select.component";
import { AdvancedFilterPanelComponent } from "./shared/advanced-filter-panel/advanced-filter-panel.component";

const sharedComponents = [
  SearchComponent,
  FooterComponent,
  TabbedComponent,
  CardSliderComponent,
  SliderComponent,
  DrawerComponent,
  NpSetLayoutDirective,
  NpSelectDirective,
  NpTableDirective,
  ValidNextPageRoutePipe,
  AlertComponent,
  ActionButtonComponent,
  ValidationComponent,
  SpinnerComponent,
  PicklistSelectComponent,
  FileUploadComponent,
  AdvancedFilterPanelComponent,
];

@NgModule({
  declarations: [sharedComponents],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
  ],
  exports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    sharedComponents,
  ],
})
export class SharedModule {}
